if( window.screen.width > 749 )
{
  var navImgHoverTargets = document.querySelectorAll(".menu-drawer__menu-item.link");
  navImgHoverTargets.forEach(function(target) 
  {
    target.addEventListener("mouseenter", function(e) 
    {
      e.preventDefault();
      
      var collectionImg = e.currentTarget.dataset.collectionImage;
      var collectionTitle = e.currentTarget.dataset.collectionTitle;
      var parent = e.currentTarget.closest("#menu-drawer"); 
      var destContainer = parent.querySelector(".dynamic-image-nav-wrapper");
  
      if( destContainer ) 
      {
        var destImg = destContainer.querySelector(".dynamic-image-nav");
        var destImgText = destContainer.querySelector(".dynamic-image-nav-overlay-text");

        // destImg.style.opacity       = '0';
        // destImgText.style.opacity   = '0'
        destContainer.style.opacity = "0";

        if (collectionImg && collectionImg != "") 
        {
          destContainer.style.display = "flex";
          destImgText.innerText = collectionTitle;

          setTimeout(function() {
            destImg.setAttribute("src", collectionImg);
            destImg.removeAttribute( "srcset" );
            destImg.onload = function() 
            {
            //   destImg.style.opacity = '1';
            //   destImgText.style.opacity   = '1';
                destContainer.style.opacity = "1";
            };
          }, 300);
        } 
        else 
        {
          destContainer.style.display = "none";
        }
      }
    });
  });
}

function closeNavDrawer()
{
  var drawer = document.querySelector( "#menu-drawer" );
  if( drawer )
  {
    var closeBtn = document.querySelector( ".menu-drawer__close-nav" );
    closeBtn.addEventListener( "click", function( e )
    {
      var parent = closeBtn.closest( "header-drawer" );
      var summary = parent.querySelector( "[id^='Details-'] summary" );
      summary.click();
    });
  }
}

// const detailsElement = document.getElementById('Details-menu-drawer-container');
// const headerElement = document.querySelector('.header');

// function updateHeaderBackground() 
// {
//     if (detailsElement.classList.contains('menu-opening') && detailsElement.hasAttribute('open')) 
//     {
//         headerElement.style.backgroundColor = '#86bbad';
//     } 
//     else 
//     {
//         headerElement.style.backgroundColor = 'transparent';
//     }
// }

// const observer = new MutationObserver(updateHeaderBackground);

// observer.observe(detailsElement, 
// {
//     attributes: true,
//     attributeFilter: ['class', 'open'], 
//     subtree: false, 
// });

// updateHeaderBackground();
closeNavDrawer();


function ItsAnImageTag( element )
{
    return ( ( element.tagName == "IMG" ) || ( element.tagName == "VIDEO" ) );
}

function ImageBehind( element )
{
    var bcr  = element.getBoundingClientRect( );
    var midL = ( bcr.left + bcr.right ) / 2;
    var midT = ( bcr.top + bcr.bottom ) / 2;
    var list = document.elementsFromPoint( midL, midT );
    var result;

    for ( var i = 0; i < list.length; i++ )
    {
        if ( ItsAnImageTag( list[ i ] ) )
        {
            result = list[ i ];
            break;
        }
    }
    return ( result );
}

// see if check is a child of element, or is element
function InTheTree( element, check )
{
    var hit;
    if ( check == element )
    {
        hit = true; // it is the element
    }
    else if ( check == undefined )
    {
        hit = false; // nothing to check
    }
    else
    {
        hit = InTheTree( element, check.parentNode ); // is the parent in ghe tree ?
    }
    return ( hit );
}
function ColourBehind( element )
{
    var bcr  = element.getBoundingClientRect( );
    var midL = ( bcr.left + bcr.right ) / 2;
    var midT = ( bcr.top + bcr.bottom ) / 2;
    var list = document.elementsFromPoint( midL, midT );
    var result;

    for ( var i = 0; i < list.length; i++ )
    {
        var check = list[ i ];
        if ( !InTheTree( element, check ) )
        {
            var s = getComputedStyle( check );
            if ( ( s.backgroundColor ) && ( s.backgroundColor != "rgba(0, 0, 0, 0)" ) && ( s.backgroundColor != "transparent" ) )
            {
                result = s.backgroundColor;
                break;
            }
        }
    }
    return ( result );
}

function CheckBG( bg, element )
{
    var pxCount = 0;
    var elBCR   = element.getBoundingClientRect( );

    if ( elBCR.width > 0 )
    {
        try
        {
            var imgBCR  = bg.getBoundingClientRect( );
            var ctxLeft = elBCR.left - imgBCR.left;
            var ctxTop  = elBCR.top - imgBCR.top;
            var id      = bg._ctx.getImageData( ctxLeft * bg._scalex, ctxTop * bg._scaley, elBCR.width * bg._scalex, elBCR.height * bg._scaley );

            var r = 0;
            var g = 0;
            var b = 0;
            var d = id.data;
            for ( var i = 0; i < d.length; i += 4 )
            {
                if ( d[ i + 3 ] > 0 )
                {
                    r += d[ i ];
                    g += d[ i + 1 ];
                    b += d[ i + 2 ];
                    pxCount++;
                }
            }
        }
        catch( e )
        {
            console.log( "failed to check background image for ", element );
            console.log( e.stack );
        }
    }

    var result;
    if ( pxCount > 0 )
    {
        r /= pxCount;
        g /= pxCount;
        b /= pxCount;

        result = { "r" : r, "g" : g, "b" : b };
    }
    return ( result );
}

function SetElementColourStyleFromCSSStyle( element, cssStyle )
{
    //console.log( "parse " + cssStyle );

    if ( cssStyle.startsWith( "rgb" ) )
    {
        var right   = cssStyle.substr( 4 );
        var mid     = right.substr( 0, right.length -1 );
        var numbers = mid.split( "," );

        if ( numbers.length == 3 )
        {
            SetElementColourStyleFromRGB( element, { "r" : Number( numbers[ 0 ].trim( ) ), "g" : Number( numbers[ 1 ].trim( ) ), "b" : Number( numbers[ 2 ].trim( ) ) } );
        }
        else
        {
            console.log( "invalid css value " + cssStyle );
        }
    }
    else
    {
        console.log( "unsupported css value " + cssStyle );
    }
}
function SetElementColourStyleFromRGB( element, rgb )
{
    // what the hell
    if ( ( rgb.r + rgb.g + rgb.b ) / 3 > 127 )
    {
        element.classList.add( "above-light-background" );
        element.classList.remove( "above-dark-background" );
    }
    else
    {
        element.classList.remove( "above-light-background" );
        element.classList.add( "above-dark-background" );
    }
}
function SetElementColourStyle( element, force )
{
    var bg = ImageBehind( element );

    if ( bg )
    {
        function RunBGCheck( )
        {
            var bgc = CheckBG( bg, element );

            if ( bgc )
            {
                SetElementColourStyleFromRGB( element, bgc );

                if ( bg.tagName == "VIDEO" )
                {
                    if ( element._videoUpdateTimer == undefined )
                    {
                        element._videoUpdateTimer = setTimeout( function( )
                        {
                            element._videoUpdateTimer = undefined;
                            SetElementColourStyle( element, true );
                            
                        }, 250 );
                    }
                }
            }
            else
            {
                var c = ColourBehind( element );
                SetElementColourStyleFromCSSStyle( element, c );
            }
        }
        if ( ( bg._ctx == undefined ) || ( force ) )
        {
            if ( bg._cbq == undefined )
            {
                bg._cbq = [ ];
                window.createImageBitmap( bg ).then( function( ib )
                {
                    var canvas = document.createElement( "canvas" );
                    //canvas.width  = bg.clientWidth;
                    //canvas.height = bg.clientHeight;
                    canvas.width  = ib.width;
                    canvas.height = ib.height;

                    var context = canvas.getContext( "2d", { "willReadFrequently" : true } );
                    context.drawImage( ib, 0, 0, bg.clientWidth, bg.clientHeight );

                    bg._ctx = context;
                    bg._scalex = bg.clientWidth / ib.width;
                    bg._scaley = bg.clientHeight / ib.height;

                    RunBGCheck( );

                    var cp = bg._cbq;
                    bg._cbq = undefined;
                    cp.forEach( function( cb ) { cb( ); } );
                } );
            }
            else
            {
                bg._cbq.push( function( ) { RunBGCheck( ); } );
            }
        }
        else
        {
            RunBGCheck( );
        }
    }
    else
    {
        var c = ColourBehind( element );
        SetElementColourStyleFromCSSStyle( element, c );
    }    
}

function SetHeaderIconColourStyles( force )
{
    var icons = document.querySelectorAll( ".header__icon, .desktop-wishlist-wrapper, .header-localization .desktop-localization-wrapper" );
    icons.forEach( function( icon )
    {
        SetElementColourStyle( icon, force );
    } );
}


var scrollDebounceHandler;
function IconScrollHandler( e )
{
    if ( scrollDebounceHandler )
    {
        clearTimeout( scrollDebounceHandler );
    }
    scrollDebounceHandler = setTimeout( function( )
    {
        SetHeaderIconColourStyles( true );
        
    }, 100 );                            
}

//console.log( "startup icon handling" );
//window.addEventListener( "scroll", IconScrollHandler );


function IconTest( force )
{
    //var icon = document.querySelectorAll( ".header__icon" )[ 1 ];
    var icon = document.querySelectorAll( ".header__icon--account" )[ 0 ];
    var bg   = ImageBehind( icon );

    if ( bg )
    {
        console.log( "got ", bg );

        if ( ( bg._ctx == undefined ) || ( force ) )
        {
            if ( bg._cbq == undefined )
            {
                bg._cbq = [ ];
                window.createImageBitmap( bg ).then( function( ib )
                {
                    var canvas = document.createElement( "canvas" );
                    canvas.width  = ib.width;
                    canvas.height = ib.height;
                    //canvas.width  = bg.clientWidth;
                    //canvas.height = bg.clientHeight;
                    
                    var context = canvas.getContext( "2d" );
                    //context.drawImage( ib, 0, 0, bg.clientWidth, bg.clientHeight );
                    context.drawImage( ib, 0, 0 ); 

                    canvas.setAttribute( "style", "position: fixed; top: 200px; left: 200px; z-index: 99999999; border: 2px solid black;" );
                    document.body.insertBefore( canvas, document.body.firstChild );
                    
                    bg._ctx = context;
                    bg._scalex = bg.clientWidth / ib.width;
                    bg._scaley = bg.clientHeight / ib.height;
                   
                    var bgc = CheckBG( bg, icon );
                    console.log( "got bgc colour ", bgc );

                    var cp = bg._cbq;
                    bg._cbq = undefined;
                    cp.forEach( function( cb ) { cb( ); } );

                    if ( bgc == undefined )
                    {
                        bgc = ColourBehind( icon );
                        console.log( "got bg colour behing image ", bgc );
                    }
                } );
            }
            else
            {
                bg._cbq.push( function( ) { CheckBG( bg, icon ); } );
            }
        }
        else
        {
            CheckBG( bg, icon );
        }
    }
    else
    {
        var c = ColourBehind( icon );
        console.log( "got bg colour " + c );
    }    
}